import './HeaderText.css';

/** From Figma — «УЛЕТНЫЙ БИЛЕТ», top 145.5 / left 284. */
export function HeaderText() {
  return (
    <div className="task-list-header-text" role="img" aria-label="Улётный билет">
      улётный билет
    </div>
  );
}
